/**
 * Escape characters that could cause trouble when string is converted in regular expression.
 */
function escapeString(str: string) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&')
}

/**
 * Create a regular expression from a list of strings.
 * This can be used for whitelisting.
 * The regex returned is not global. Methods like test() can be called multiple times.
 * @param strings eg: ['example.com', 'anotherdomain.com']
 * @returns A regular expression like /example\.com|anotherdomain\.com/mi
 */
function regexFromStrings(strings: string[]) {
  return new RegExp(strings.map(escapeString).join('|'), 'mi')
}

/**
 * Get a function that can check if a word is present in a particular list
 * Takes into account special characters and is case insensitive.
 * @param strings List of words
 */
function getWordListCheck(strings: string[]) {
  const regex = regexFromStrings(strings)
  return function checkWord(word: string) {
    return regex.test(word)
  }
}

/**
 * First character is alphanumeric, then 2 to 18 characters, last character is alphanum
 * [a-zA-Z0-9] an alphanumeric THEN (
 * _(?!\.) a _ not followed by a . OR
 * \.(?!_) a . not followed by a _ OR
 * [a-zA-Z0-9] an alphanumeric ) FOR
 * {2,18} minimum 2 to maximum 18 times THEN
 * [a-zA-Z0-9] an alphanumeric
 */
function matchUserName(str: string) {
  const regex = /[a-zA-Z0-9](_(?!(\.|_))|\.(?!(_|\.))|[a-zA-Z0-9]){2,18}[a-zA-Z0-9]/g
  return str.match(regex)
}

/**
 * [a-zA-Zа-яА-Я] first character is letter only
 * [^a-zA-Zа-яА-Я-Z0-9] an alphanumeric FOR
 * {2,18} minimum 3 to maximum 18 times
 * @returns string with warning
 */
function matchAlias(str: string) {
  const regex = /^[a-zA-Zа-яА-Я-Z0-9]{3,18}$/g

  return str.match(regex)
    ? str[0].match(/[a-zA-Zа-яА-Я]/)
      ? ''
      : 'First character is a letter only'
    : 'Please use only letters or numbers'
}

export default {
  escapeString,
  matchAlias,
  matchUserName,
  regexFromStrings,
  getWordListCheck,
}
